
<template>
     <a-tabs v-model="value" @change="tabChange">
        <a-tab-pane v-for="item in data" :key="item.platformcode" :tab="item.platformname">
        </a-tab-pane>
    </a-tabs>
</template>
<script>

export default {
    data() {
        return {
            data: [],
            value:''
        }
    },

    props:{
    },
    mounted(){
        this.getPlatformList();
    },
    methods: {
        tabChange(v) {
            this.value = v;
            this.$emit('platformcodeChange',v);
        },

        getPlatformList() {
            let that = this;
            let c_params = {
                urlparams: false,
            }

            that.$store.dispatch({
                type: "filemanager/queryPlatformList",
                params: c_params,
                showMsg: false
            }).then((res) => {
                if (res.data.success == 1) {
                    that.data = res.data.data;
                    const {query} = that.$route;
                    if(that.data.length > 0){
                        if(query.platformcode){
                            that.tabChange(query.platformcode)
                        }
                        else{
                            that.tabChange(that.data[0].platformcode)
                        }
                    }
                }
            })
        },
    },
   
};
</script>

<style scoped>

</style>
